exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#offrePro .title{text-align:left;font:normal normal 700 2.8em Dosis;letter-spacing:0;color:#000;opacity:1}#offrePro .subtitle{font:normal normal 700 1.8em Segoe UI}#offrePro .content,#offrePro .subtitle{text-align:left;letter-spacing:0;color:#707070;opacity:1}#offrePro .content{font:normal normal normal 1.2em Segoe UI}#offrePro li{text-align:left;margin:10px}#offrePro li::marker{color:#635bff;font-size:25px}#offrePro button{background:#635bff 0 0 no-repeat padding-box;box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);border-radius:62px;opacity:1;width:300px;border:none;margin:auto}", ""]);

// exports
